/**
 * @file Filename search reducer.
 */

import { UPDATE_ALBUM_FOLDER_FILENAME_SEARCH } from '../actions/album-folder-filename-search';

export const initialState = {
  searchQuery: '',
  entityId: null,
};

const albumFolderFilenameSearchReducer = (
  state = initialState,
  action = {},
) => {
  switch (action.type) {
    case UPDATE_ALBUM_FOLDER_FILENAME_SEARCH:
      return {
        ...state,
        searchQuery: action.searchQuery,
        entityId: action.entityId,
      };
    default:
      return state;
  }
};

export default albumFolderFilenameSearchReducer;
